// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_yuK","title":"styles_title__2Uo2X"};